import { render } from "./MobileSetColor.vue?vue&type=template&id=7dbff724&scoped=true"
import script from "./MobileSetColor.vue?vue&type=script&lang=js"
export * from "./MobileSetColor.vue?vue&type=script&lang=js"

import "./MobileSetColor.vue?vue&type=style&index=0&id=7dbff724&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7dbff724"

export default script